import React, { ReactNode } from 'react';

interface ChildrenProps {
    children?: ReactNode;
}

const Then = ({ children }: ChildrenProps) => <>{children}</>;
const Else = ({ children }: ChildrenProps) => <>{children}</>;

interface IfProps {
    condition: boolean;
    children?: ReactNode;
}

const If = ({ condition, children }: IfProps): ReactNode => {
    if (!children) {
        return null;
    }

    // <If>text</If>
    if (typeof children === 'string' && condition) {
        return children;
    }

    if (Array.isArray(children)) {
        const childrenElements = children as React.ReactElement[];
        // <If><div>text</div><div>text2></If>
        if (childrenElements.every((e) => e.type !== Else)) {
            return condition && children;
        }
        // <If><Then>text</Then><Else>text2</Else></If>
        return childrenElements.find((e) => (condition && e.type === Then) || (!condition && e.type === Else));
    }

    // <If><div>text</div></If>
    const childElement = children as React.ReactElement;
    if ((condition && (!childElement?.type || childElement.type !== Else)) || (childElement.type === Else && !condition)) {
        return children;
    }

    return null;
};

export { If, Then, Else };
